import React from 'react';
import { useInbox } from '../application/useInbox';

// Inner Components
import { ConversationSidebar } from './CampaignSidebar';
import { ChatWindow } from './MessageList';

export const InboxLayout: React.FC = () => {
  const inboxState = useInbox();
  const hasSelection = Boolean(inboxState.selectedPhoneNumber);

  return (
    <div className="inbox-layout flex bg-white md:rounded-xl md:shadow-sm md:border md:border-gray-100 overflow-hidden">
      {/* LEFT SIDEBAR: Conversations (en móvil solo se ve si no hay chat abierto) */}
      <div
        className={`${hasSelection ? 'hidden md:flex' : 'flex'} w-full md:w-[40%] md:min-w-[240px] md:max-w-[350px] md:border-r md:border-gray-200 flex-col bg-gray-50/30`}
      >
        <ConversationSidebar
          conversations={inboxState.conversations}
          selectedPhoneNumber={inboxState.selectedPhoneNumber}
          onSelectConversation={inboxState.setSelectedPhoneNumber}
          onSearch={inboxState.setConversationSearch}
          loading={inboxState.loadingConversations}
          incomingMessageTick={inboxState.incomingMessageTick}
        />
      </div>

      {/* RIGHT PANEL: Chat Window (en móvil solo se ve con un chat abierto) */}
      <div className={`${hasSelection ? 'flex' : 'hidden md:flex'} flex-1 min-w-0 flex-col bg-white`}>
        <ChatWindow
          messages={inboxState.messages}
          loading={inboxState.loadingMessages}
          hasMore={inboxState.hasMore}
          onLoadMore={inboxState.loadMore}
          selectedConversation={inboxState.selectedConversation}
          onSendMessage={inboxState.sendMessage}
          onSendMediaFiles={inboxState.sendMediaFiles}
          sendingMedia={inboxState.sendingMedia}
          onBack={() => inboxState.setSelectedPhoneNumber(undefined)}
        />
      </div>
    </div>
  );
};
